import { LocationPicker } from 'components/location/picker/LocationPicker';
import { usePopup } from 'hooks/usePopup';
import { LocationDetailsDto } from 'services/utils/location/locationService.dto';

interface ShowLocationPickerOptions {
  defaultLocation?: LocationDetailsDto;
  markerRadiusMiles?: number;
  buttonLabel?: string;
  onConfirm: (location: LocationDetailsDto) => void;
}

export const useLocationPickerPopup = () => {
  const { showPopup, hidePopup } = usePopup();

  const showLocationPicker = ({
    defaultLocation,
    markerRadiusMiles,
    buttonLabel,
    onConfirm,
  }: ShowLocationPickerOptions) => {
    showPopup(
      <LocationPicker
        defaultLocation={defaultLocation}
        markerRadiusMiles={markerRadiusMiles}
        buttonLabel={buttonLabel}
        onConfirm={location => {
          hidePopup();
          onConfirm(location);
        }}
      />,
      { keepPopups: true, paddingVariant: 'NONE' }
    );
  };

  return { showLocationPicker };
};
